'use client';

import { FC, useMemo, useRef } from 'react';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons/icomoon';
import { NavigationItemData } from '@wwe-portal/ui/components/navigation';
import { NavigationMenu } from '@wwe-portal/ui/components/navigation/navigation';
import { useNavigation } from '@wwe-portal/ui/components/navigation/use-navigation';

import { RBE_SECTIONS } from '@wwe-portal/web/utils/constants/rbe';
import { useListenStickyElement } from '../../../../../packages/ui/hooks/use-listen-sticky-element';

export const RbeNavigationMenu: FC<{
  hasGlobalEvents: boolean;
  hasSoloEvents: boolean;
  globalFirst: boolean;
  pageTitle: React.ReactNode;
}> = ({ hasGlobalEvents, hasSoloEvents, globalFirst, pageTitle }) => {
  const ref = useRef<HTMLDivElement>(null);

  useListenStickyElement(ref, (value) => {
    if (typeof ref !== 'object' || ref.current == null) return;
    ref.current.setAttribute('data-sticky', String(value));
  });

  const menuItems: NavigationItemData[] = useMemo(() => {
    const items: NavigationItemData[] = [];
    if (hasSoloEvents) {
      items.push({
        id: RBE_SECTIONS.SOLO_EVENT_SECTION,
        label: 'Solo',
        icon: <IcoMoonIcon iconName="user" className="h-[18px] w-[18px]" />,
      });
    }
    if (hasGlobalEvents) {
      items.push({
        id: RBE_SECTIONS.GLOBAL_EVENT_SECTION,
        label: 'Global',
        icon: (
          <IcoMoonIcon iconName="compass-fill" className="h-[18px] w-[18px]" />
        ),
      });
    }
    if (globalFirst) {
      items.reverse();
    }

    return items;
  }, [hasGlobalEvents, hasSoloEvents]);

  const { activeId, handleItemClick, lockedActiveId } =
    useNavigation(menuItems);

  return (
    <>
      {pageTitle}
      <div className="sticky inset-x-0 top-[55px] z-[490] py-5 md:fixed md:px-5 md:py-[30px] xl:left-[240px] xl:right-[280px] xl:top-[65px] xl:px-[30px]">
        <div className="md:flex md:flex-row md:items-center md:justify-end">
          <NavigationMenu
            items={menuItems}
            activeId={lockedActiveId ?? activeId}
            onClick={handleItemClick}
            className="grid grid-flow-col justify-stretch"
          />
        </div>
      </div>
    </>
  );
};
